import { CountryTaxes } from "../../types/tax-types/TaxTypes";

export const taxData: CountryTaxes = {
  India: {
    GST: [
      {
        headers: ["Rate (%)", "Description", "Cess (if applicable)"],
        data: [
          {
            rate: "0%",
            description:
              "Essential goods (e.g., milk, bread, healthcare services)",
            cess: "N/A",
          },
          {
            rate: "5%",
            description: "Common goods (e.g., apparel < ₹1,000, spices)",
            cess: "N/A",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2020",
          effectiveTo: "31/12/2021",
        },
      },
      {
        headers: ["Rate (%)", "Description", "Cess (if applicable)"],
        data: [
          {
            rate: "12%",
            description: "Processed foods, business-class air travel",
            cess: "N/A",
          },
          {
            rate: "18%",
            description: "Most goods/services (e.g., electronics, IT services)",
            cess: "N/A",
          },
          {
            rate: "28%",
            description: "Luxury items (e.g., cars, tobacco) + sin goods",
            cess: "1% to 204% (e.g., tobacco, luxury cars)",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2022",
          effectiveTo: "31/12/2022",
        },
      },
    ],
    TDS: [
      {
        headers: ["Rate (%)", "Applicable To", "Threshold (₹)"],
        data: [
          {
            rate: "1%",
            description: "Purchase of goods",
            threshold: "50,00,000",
          },
          { rate: "2%", description: "GST payments", threshold: "2,50,000" },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2020",
          effectiveTo: "30/06/2021",
        },
      },
      {
        headers: ["Rate (%)", "Applicable To", "Threshold (₹)"],
        data: [
          { rate: "10%", description: "Rent", threshold: "2,40,000/year" },
          {
            rate: "20%",
            description: "Interest/dividends (no PAN)",
            threshold: "N/A",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/07/2021",
          effectiveTo: "30/06/2022",
        },
      },
    ],
    PT: [
      {
        static: true,
        applicableDate: {
          effectiveFrom: "01/01/2020",
          effectiveTo: "31/03/2021",
        },
      },
      {
        static: true,
        applicableDate: {
          effectiveFrom: "01/04/2021",
          effectiveTo: "31/03/2022",
        },
      },
    ],
  },
  KSA: {
    Zakat: [
      {
        headers: ["Rate (%)", "Applicable To", "Notes"],
        data: [
          {
            rate: "2.5%",
            description: "Business profits (Zakat)",
            notes: "For Muslim-owned businesses",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2020",
          effectiveTo: "31/12/2021",
        },
      },
      {
        headers: ["Rate (%)", "Applicable To", "Notes"],
        data: [
          {
            rate: "2.5%",
            description: "Business profits (Zakat) - Updated",
            notes: "For Muslim-owned businesses - Revised rates",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2022",
          effectiveTo: "31/12/2023",
        },
      }
    ],
    WithholdingTax: [
      {
        headers: ["Rate (%)", "Applicable To", "Threshold"],
        data: [
          {
            rate: "5%",
            description: "Dividends (25% ownership)",
            threshold: "N/A",
          },
          {
            rate: "10%",
            description: "Dividends (other cases)",
            threshold: "N/A",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2020",
          effectiveTo: "30/06/2021",
        },
      },
      {
        headers: ["Rate (%)", "Applicable To", "Threshold"],
        data: [
          {
            rate: "5%",
            description: "Royalties (equipment use)",
            threshold: "N/A",
          },
          {
            rate: "15%",
            description: "Technical services",
            threshold: "N/A",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/07/2021",
          effectiveTo: "30/09/2022",
        },
      }
    ],
    VAT: [
      {
        headers: ["Rate (%)", "Description", "Notes"],
        data: [
          {
            rate: "15%",
            description: "Most goods and services",
            notes: "Standard rate as of 2020",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2020",
          effectiveTo: "31/12/2021",
        },
      },
      {
        headers: ["Rate (%)", "Description", "Notes"],
        data: [
          {
            rate: "15%",
            description: "Most goods and services - Updated",
            notes: "Standard rate as of 2022",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2022",
          effectiveTo: "31/12/2023",
        },
      }
    ],
  },
  "United Kingdom": {
    IncomeTax: [
      {
        headers: ["Rate (%)", "Income Band (GBP)", "Notes"],
        data: [
          { rate: "20%", description: "12,571 - 50,270", notes: "Basic rate" },
          { rate: "40%", description: "50,271 - 125,140", notes: "Higher rate" },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2020",
          effectiveTo: "05/04/2021",
        },
      },
      {
        headers: ["Rate (%)", "Income Band (GBP)", "Notes"],
        data: [
          { rate: "45%", description: "Above 125,140", notes: "Additional rate" },
        ],
        applicableDate: {
          effectiveFrom: "06/04/2021",
          effectiveTo: "05/04/2022",
        },
      }
    ],
    NIC: [
      {
        headers: ["Rate (%)", "Income Band (GBP)", "Notes"],
        data: [
          {
            rate: "8%",
            description: "12,570 - 50,284",
            notes: "Class 1, main rate",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2020",
          effectiveTo: "31/12/2020",
        },
      },
      {
        headers: ["Rate (%)", "Income Band (GBP)", "Notes"],
        data: [
          {
            rate: "2%",
            description: "Above 50,284",
            notes: "Class 1, additional rate",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2021",
          effectiveTo: "31/12/2021",
        },
      }
    ],
    VAT: [
      {
        headers: ["Rate (%)", "Description", "Notes"],
        data: [
          {
            rate: "20%",
            description: "Most goods and services",
            notes: "Standard rate",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2020",
          effectiveTo: "31/12/2021",
        },
      },
      {
        headers: ["Rate (%)", "Description", "Notes"],
        data: [
          {
            rate: "20%",
            description: "Most goods and services - Updated",
            notes: "Standard rate - Revised",
          },
        ],
        applicableDate: {
          effectiveFrom: "01/01/2022",
          effectiveTo: "30/06/2023",
        },
      }
    ],
  },
};
